import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "position-absolute top-0 start-0 mx-5 mt-5 d-lg-block w-200px w-md-200px w-xl-220px mb-sm-5 mb-lg-0",
  src: "media/logos/MIGU.Gob.jpg",
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "text-center my-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "fv-plugins-message-container" }
const _hoisted_5 = { class: "fv-help-block" }
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = { class: "d-flex flex-stack mb-2" }
const _hoisted_12 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = {
  tabindex: "3",
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-10"
}
const _hoisted_18 = { class: "indicator-label" }
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_21 = { class: "text-gray-500 text-center fw-semibold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Form, {
      class: "form",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("authSigninTitulo")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.messageError), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("authSigninUsernameLabel")), 1),
          _createVNode(_component_Field, {
            tabindex: "1",
            class: "form-control form-control-lg form-control-solid",
            type: "email",
            name: "username",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorMessage, { name: "username" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("authSigninPasswordLabel")), 1)
          ]),
          _createVNode(_component_Field, {
            name: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, {
            default: _withCtx(({ field }) => [
              _withDirectives(_createElementVNode("input", _mergeProps({
                tabindex: "2",
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                ref: "passwordInput"
              }, field), null, 16), [
                [_vModelText, _ctx.password]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: "/password-reset",
              class: "link-primary fs-6 fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("authSigninForgotPasswordLink")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("authSigninSigninBtn")), 1),
            _createElementVNode("span", _hoisted_19, [
              _createTextVNode(_toDisplayString(_ctx.$t("indicatorProgress")) + " ", 1),
              _hoisted_20
            ])
          ], 512),
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.$t("authSigninNewUser")) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/home",
              class: "link-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("authSigninSolicitaAcceso")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ], 64))
}